import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const BASE_URL = `${API_URL}/users`;

export function mergeUsers({ sourceId, destinationId, deleteSourceAfterMerge }) {
    return post(`${BASE_URL}/merge/${sourceId}/${destinationId}?deleteSourceAfterMerge=${!!deleteSourceAfterMerge}`);
}
